import Ajax from "Utils/ajax";
export const getAllMenu = (data) => Ajax.post('admin/getAllMenu',data);
export const getAllModule = (data) => Ajax.post('admin/getAllModule',data);
export const getAllParent = (data) => Ajax.post('admin/getAllParent',data);
export const addUpdateMenu = (data) => Ajax.post('admin/addUpdateMenu',data);